import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { DashboardResponse } from '../models/dashboard.model';
import { ToastService } from 'src/app/shared/toasts/toast-service';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DashboardService {
  private apiUrl = `${environment.apiUrl}/whatsapp/dashboard`;

  constructor(
    private http: HttpClient,
    private toastService: ToastService
  ) {}

  obterMetricas(): Observable<DashboardResponse> {
    return this.http.get<DashboardResponse>(this.apiUrl).pipe(
      catchError((error) => {
        this.toastService.show('Erro ao carregar métricas do dashboard', {
          classname: 'bg-danger text-light',
        });
        return throwError(() => error);
      })
    );
  }
}
